var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-icon',{staticClass:"delete-button",attrs:{"small":""},on:{"click":_vm.deleteFile}},[_vm._v(" mdi-delete ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }